import CurrentAccount from './CurrentAccount'

export default CurrentAccount
